import React from 'react';
import * as MyCells from '../../../utils/Cells';
import ActionMenu from '../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../common/filters/Filters';
import MultiSelectColumnFilter from '../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Típus',
            accessor: 'closeObjectTypeLabel',
            id: 'closeObjectTypeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Sorszám',
            accessor: 'closeObjectPublicId',
            id: 'closeObjectPublicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Partner',
            accessor: 'closeObjectName',
            id: 'closeObjectName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Info',
            accessor: 'closeObjectInfo',
            id: 'closeObjectInfo',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Lezárt Összeg',
            accessor: 'closeAmount',
            id: 'closeAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Művelet',
            accessor: 'closeTypeLabel',
            id: 'closeTypeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Művelet Dátuma',
            accessor: 'closeDate',
            id: 'closeDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Művelet Megjegyzése',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'close'} refresh={refresh} />,
        },
    ]
}